export const ActionsLabels: Record<string, string> = {
    read: "Leitura",
    create: "Cadastro",
    update: "Atualização",
    remove: "Remoção",
};
